export function isPlainObject(value: unknown): value is Record<string, unknown> {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}

/**
 * Field names come from the model, so a key like `__proto__.isAdmin` would otherwise
 * walk into Object.prototype and pollute every object in the app.
 */
const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

const isUnsafeKey = (key: string): boolean => UNSAFE_KEYS.has(key);

function setPath(target: Record<string, unknown>, path: string, value: unknown): void {
    const parts = path.split('.');
    if(parts.some(isUnsafeKey)) {
        return;
    }
    let cursor: Record<string, unknown> = target;
    for(let i = 0; i < parts.length - 1; i++) {
        const key = parts[i];
        if(!isPlainObject(cursor[key])) {
            cursor[key] = {};
        }
        cursor = cursor[key] as Record<string, unknown>;
    }
    cursor[parts[parts.length - 1]] = value;
}

export function deepMerge(
    base: Record<string, unknown>,
    patch: Record<string, unknown>,
): Record<string, unknown> {
    const result: Record<string, unknown> = {...base};
    Object.entries(patch).forEach(([key, value]) => {
        if(isUnsafeKey(key)) {
            return;
        }
        if(isPlainObject(value) && isPlainObject(base[key])) {
            result[key] = deepMerge(base[key] as Record<string, unknown>, value);
            return;
        }
        result[key] = value;
    });
    return result;
}

/** Expand `"date.startDate": x` into `{ date: { startDate: x } }`. */
export function expandFlatFields(fields: Record<string, unknown>): Record<string, unknown> {
    const patch: Record<string, unknown> = {};
    Object.entries(fields).forEach(([name, value]) => {
        if(name.includes('.')) {
            setPath(patch, name, value);
            return;
        }
        if(isUnsafeKey(name)) {
            return;
        }
        patch[name] = value;
    });
    return patch;
}
